import { MaskedInput as AntdMaskedInput } from 'antd-mask-input';

export const MaskedInput = AntdMaskedInput;
export type MaskedInputProps = React.ComponentProps<typeof AntdMaskedInput>;
